function ClientReferenceNumberInput($form) {
    var clientRefselector = `${$form.selector} #clientPopupReferenceNumber`;
    var clientRefselectorError = `${$form.selector} #clientRefrenceNumberError`;
    var btnSaveSelector = `${$form.selector} .btn-save`;

    var orgInputSelector = `${$form.selector} input[name="OrganizationID"]`;
    var orgSelectSelector = `${$form.selector} select[name="OrganizationID"]`;

    var originalRefNumber = '';

    var DEFAULT_URL = "/partner-portals/dva/clients/ValidateClient/";
    var DEFAULT_TYPE = "get";

    var m = {
        init: function() {
            m.clearError();

            $(clientRefselector).unbind('focus');
            $(clientRefselector).unbind('keyup');
            $(clientRefselector).unbind('change');

            $(clientRefselector).on("focus", m.setRefNumber);
            $(clientRefselector).on("keyup", m.checkIfDifferentRefNumber);
            $(clientRefselector).on("change", m.checkValidRefNumber);
        },

        getRefNumber: function() {
            return $(clientRefselector).val();
        },

        setRefNumber: function() {
            originalRefNumber = m.getRefNumber();
        },

        checkIfDifferentRefNumber: function() {
            currentRefNumber = m.getRefNumber();

            $(btnSaveSelector).attr("disabled", (originalRefNumber !== currentRefNumber));
        },

        clearError: function() {
            $(clientRefselector).removeClass('error');
            $(clientRefselectorError).hide();
            $(btnSaveSelector).removeAttr("disabled");
        },

        showError: function(msg) {
            setTimeout(function() { $(clientRefselector).addClass('error'); }, 100);
            $(clientRefselectorError).addClass('pt-1');
            $(clientRefselectorError).addClass('mb-0');
            $(clientRefselectorError).text(msg);
            $(clientRefselectorError).show();
            $(btnSaveSelector).attr("disabled", true);
        },

        checkValidRefNumber: function() {
            var url  = $(clientRefselector).data('url') || DEFAULT_URL;
            var type = $(clientRefselector).data('type') || DEFAULT_TYPE;
            var errorMsg = $(clientRefselectorError).text();

            Core.ShowPageLoading();
            m.clearError();

            var refNumber = m.getRefNumber();
            var contactID = ($("#ContactId").length > 0) ? $("#ContactId").val() : "";
            var orgaID    = ($(orgSelectSelector).length > 0) ? $(orgSelectSelector).val() : $(orgInputSelector).val();

            // check if refNumber is not empty or whitespace only
            if (refNumber.trim() === '') {
                Core.HidePageLoading();
                m.showError('This field is required.');
                return;
            }

            $.ajax({
                url: url,
                data: {
                    clientrefrencenumber: refNumber,
                    contactID: contactID,
                    organizationID: orgaID
                },
                type: type,
                dataType: 'json',
                success: function (output) {
                    (output.Result)
                        ? m.clearError()
                        : m.showError(errorMsg);
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    m.showError('An issue with the api occurred. Try later.');
                },
                complete: function() {
                    Core.HidePageLoading();
                },
            });
        },
    };

    m.init();

    return m;
} 
